import React from 'react'
import { useAppData } from '../../../../context/AppDataContext'
import AppLayout from '../../../../layout/components/AppLayout';

import { Link } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import ClinicForm from '../../../clinic/components/ClinicForm';
import ClinicSearch from '../../../clinic/components/ClinicSearch';

import { useEffect, useState } from 'react';
import clinicTeamServices from '../../../clinic/clinicTeamServices';
import ReceivedPendingRequestList from '../component/ReceivedPendingRequestList';


function AssociatedClinicPage() {
    const {associatedClinicList,getAssociateClinicList,getReceivedJoinRequest} = useAppData();
    const {authUser} = useAuth();
    


    const [sentPendingRequest,setSentPendingRequest] = useState(null);
    const [receivedPendingRequest,setSenReceivedPendingRequest] = useState(null);

    const getSentPendingRequest = () =>{
        clinicTeamServices.getSentPendingRequest().then(res=>{
            setSentPendingRequest(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    const getReceivedPendingRequest = () =>{
        clinicTeamServices.getReceivedPendingRequest().then(res=>{
            setSenReceivedPendingRequest(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }
    
    useEffect(()=>{
        getSentPendingRequest();
        getReceivedPendingRequest();
    },[])

    const refreshData = () =>{
        getSentPendingRequest();
        getReceivedPendingRequest();
        getAssociateClinicList();
        getReceivedJoinRequest();
    }


    return (
        <AppLayout>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        {associatedClinicList && associatedClinicList.length === 0 &&
                            <div className="alert alert-warning" role="alert">
                                <h4 className="alert-heading">Setup Clinic!</h4>
                                <p>You are not part of any clinic.</p>
                                <hr/>
                                <p>Join any clinic or setup a new clinic to continue</p>
                            </div>
                        }
                    </div>
                    <div className='col-md-6'>
                        <ClinicSearch />
                    </div>
                    <div className='col-md-6'>
                        <ClinicForm callBack={refreshData} />
                    </div>
                    <div className='col-md-12'>
                        <div className='card mb-3'>
                            <div className='card-header bg-primary text-white'>My Clinic List</div>
                            {associatedClinicList && associatedClinicList.length > 0 &&
                                <table className='table mb-0'>
                                    <thead>
                                        <tr>
                                            <th>Clinic</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {associatedClinicList && associatedClinicList.map(clinic =>
                                            <tr key={clinic.id}>
                                                <td><Link to={"/clinic/"+clinic.id}>{clinic.title}</Link></td>
                                                <td>{clinic.associateId == authUser.associateId && <ClinicForm callBack={refreshData} data={clinic} /> }</td>
                                            </tr>
                                        )}                                  
                                    </tbody>
                                </table>
                            }
                        
                            <div className='card-footer'>
                                <table className='table mb-0'>
                                    <tbody>
                                        {sentPendingRequest?.map(item=>
                                            <tr key={item.id}>
                                                <td>{item.title}</td>
                                                <td>
                                                    {item.requestStatus ==0 && <span className='p-2 px-3 bg-warning rounded-pill'>Request Sent</span>}
                                                    {item.requestStatus ==2 && <span className='p-2 px-3 bg-warning rounded-pill'>Request Sent</span>}
                                                    {item.requestStatus ==3 && <span className='p-2 px-3 bg-danger rounded-pill'>Rejected</span>}
                                                </td>
                                            </tr>
                                            
                                        )}
                                    </tbody>
                                    
                                </table>
                            </div>
                        </div>
                        
                    </div>
                    
                    <div className='col-md-12'>
                        <h5 className='text-success'>Join request for your clinic</h5>
                    </div>
                    <div className='col-md-12'>
                        <ReceivedPendingRequestList receivedPendingRequest={receivedPendingRequest} callBack={refreshData} />
                    </div>
                </div>
            </div>
            
        </AppLayout>
    )
}

export default AssociatedClinicPage